import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

export default function Hero({ settings }) {
  const { lang, t } = useLang();
  const [videoFailed, setVideoFailed] = useState(false);

  const title = settings?.heroTitle?.[lang] || t.hero.title;
  const subtitle = settings?.heroSubtitle?.[lang] || t.hero.subtitle;
  const cta = settings?.heroCTA?.[lang] || t.hero.cta;
  const videoUrl = settings?.heroVideo;
  const posterUrl = settings?.heroPoster;

  const scrollToCatalog = () => {
    document.getElementById("catalog")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[90vh] md:min-h-screen w-full overflow-hidden bg-[#0C0C0C]" data-testid="hero-section">
      {/* Video / Poster */}
      <div className="absolute inset-0">
        {!videoFailed && videoUrl ? (
          <video
            data-testid="hero-video"
            autoPlay muted loop playsInline preload="metadata"
            poster={posterUrl}
            onError={() => setVideoFailed(true)}
            className="w-full h-full object-cover">
            <source src={videoUrl} type="video/mp4" />
          </video>
        ) : (
          <img src={posterUrl} alt="Spain Luxury Rentals" className="w-full h-full object-cover" />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0C0C0C]/40 via-[#0C0C0C]/60 to-[#0C0C0C]" />
        <div className="absolute inset-0 bg-[#0C0C0C]/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 min-h-[90vh] md:min-h-screen flex flex-col justify-end pb-24 md:pb-32 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-[#C9A55A]" />
            <span className="text-overline text-[#C9A55A]">Costa Blanca · Alicante</span>
          </div>
          <h1 className="font-display text-[#F5F1EB] text-4xl sm:text-5xl md:text-7xl lg:text-8xl max-w-5xl"
              data-testid="hero-title">
            {title}
          </h1>
          <p className="mt-6 md:mt-8 text-base md:text-lg text-[#F5F1EB]/80 font-light max-w-xl"
             data-testid="hero-subtitle">
            {subtitle}
          </p>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={scrollToCatalog}
            data-testid="hero-cta"
            className="btn-gold mt-10">
            {cta}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M5 12l7 7 7-7"/>
            </svg>
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}
